import { DASHBOARD_CARD_CONFIG } from './dashboard.mapper'

export const mapDashboardToCards = (dashboard) => {
  const {
    estimatedPensionCurrentMonth,
    lastPensionValue,
    lastPensionTargetMonth,
    currentUtmValue,
    // Exclude if an old RPC still returns this field.
    pensionFactor: _ignoredPensionFactor,
    nextPensionValue,
    nextPaymentDate,
    ...rest
  } = dashboard

  return Object.entries(rest)
    .filter(([_, value]) => value !== null) // opcional
    .map(([key, value]) => {
      const config = DASHBOARD_CARD_CONFIG[key] || {
        icon: 'las la-chart-bar',
        label: key,
        format: (v) => v, // default formatter
      }

      return {
        key,
        value: config.format ? config.format(value) : value ?? 0,
        rawValue: value, // útil para lógica futura
        ...config,
      }
    })
    .sort((a, b) => a.order - b.order)
}
